import React from 'react';
import { AvatarInitialSC } from './avatar-initials.styled';
import { AvatarInitialsProps } from './avatar-initials.types';
import {
  createInitialsFromName,
  createInitialsFromProfile,
  createInitialsFromString,
  useAvatarColors,
} from './avatar-initials.utils';
import classNames from 'classnames';

const AvatarInitials = ({
  size = 'medium',
  initials,
  style,
  className,
  ...rest
}: AvatarInitialsProps) => {
  const { colors } = useAvatarColors(initials?.slice(0, 2) ?? '-');

  return (
    <AvatarInitialSC
      className={classNames('ui-avatar-initials', className, size)}
      style={Object.assign({}, colors, style)}
      {...rest}
    >
      {initials}
    </AvatarInitialSC>
  );
};

AvatarInitials.fromName = createInitialsFromName;
AvatarInitials.fromProfile = createInitialsFromProfile;
AvatarInitials.fromString = createInitialsFromString;

export default AvatarInitials;
